import * as React from "react"

const Title = ({text, className,...props}) => (
  <h1 data-scroll className={"m0 p10 pt0 text-center text-light "+(className ? className : '')}  {...props}>{text}</h1> 
) 
export default Title
